import script from "./GuideStep4.vue?vue&type=script&setup=true&lang=js"
export * from "./GuideStep4.vue?vue&type=script&setup=true&lang=js"

import "./GuideStep4.vue?vue&type=style&index=0&id=2ce026bd&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce026bd"]])

export default __exports__